module.exports = __webpack_public_path__ + "media/images/jumping/jump-098c63194adede8cbcf3a2084be59dd8.png";